import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { useLocales } from 'src/locales';

import { useActingClientOptional } from './acting-client-context';

/**
 * NAT-2497 — the venue selector in the header (spec §6).
 *
 * Shown only to a customer holding several venues; hidden for the
 * single-venue majority, who see no change, and for agents and admins, who
 * keep the client picker the catalogue already has. Switching writes this
 * tab's selection; every client-scoped SWR key carries the id, so the
 * catalogue, cart, prices and orders re-fetch for the new venue.
 */
export function VenueSelector() {
  const { t } = useLocales();
  const acting = useActingClientOptional();

  if (!acting || !acting.showSelector) return null;

  return (
    <TextField
      select
      size="small"
      label={t('acting_client_selector_label')}
      value={acting.actingClientId ?? ''}
      onChange={(event) => acting.setActingClientId(event.target.value || null)}
      sx={{ minWidth: 200, mr: 1 }}
    >
      {acting.grants.map((grant) => (
        <MenuItem key={grant.id} value={String(grant.id)}>
          {grant.name || grant.slug}
        </MenuItem>
      ))}
    </TextField>
  );
}
